import { render, staticRenderFns } from "./sendTransfers.vue?vue&type=template&id=65098ac9&"
import script from "./sendTransfers.vue?vue&type=script&lang=js&"
export * from "./sendTransfers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports